import packagejson from '../../../package.json';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { post } from '../../utils/httpRequest';
import { CLIENT_IDENTIFICATION } from '../resources/constants';

const MONTHS_13 = 34160000000;
const version = packagejson.version;

export const identifyAnalyticsClient = (): Promise<Response> => {
  const actualDate = new Date().getTime();
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const dateFromStorage = parseInt(
    storageClient?.getFromStorage('localStorage', CLIENT_IDENTIFICATION, '0')
  );
  let dateToSend = dateFromStorage;
  if (!dateFromStorage || actualDate - MONTHS_13 > dateFromStorage) {
    storageClient?.setInStorage(
      'localStorage',
      CLIENT_IDENTIFICATION,
      actualDate.toString()
    );
    dateToSend = actualDate;
  }
  const extraHeaders = {
    'Odigeo-Module-Info': `frontend-tracking-agent:${version}`,
  };

  return post(
    '/analytics-client-identification/v3/identifyClient',
    dateToSend,
    extraHeaders
  );
};
